import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#42DA4C",
      d: "M4.5.75c0-.416.334-.75.75-.75h3.5c.416 0 .75.334.75.75s-.334.75-.75.75h-1v1.544a6.45 6.45 0 0 1 3.556 1.59l.913-.915a.75.75 0 0 1 1.06 1.06l-.97.968A6.499 6.499 0 0 1 7 15.997a6.498 6.498 0 0 1-.75-12.953V1.5h-.999A.75.75 0 0 1 4.5.75M7 14.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10m.75-7.75V10c0 .416-.334.75-.75.75a.75.75 0 0 1-.75-.75V6.75c0-.416.334-.75.75-.75s.75.334.75.75"
    }, null, -1)
  ]))]))
}
export default { render: render }